import { render, staticRenderFns } from "./SelectStatusReasons.vue?vue&type=template&id=0e3a1934"
import script from "./SelectStatusReasons.vue?vue&type=script&lang=js"
export * from "./SelectStatusReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports